import { simpleSet } from '@r/reducers/utils';

const setCalculationModeHingesOptions = simpleSet as
  redux.reducers.calculationMode.settings.materials.hinges.options;

export const options = setCalculationModeHingesOptions(
  'SET_CALCULATION_MODE_HINGES_OPTIONS',
  []
);
